<template>
    <v-card class="score-chart ma-1" justify="center">
        <v-container>
            <v-card flat class="score-semitrans-25 margin_outer" min-height="250">
                <v-responsive>
                    <v-row justify="center">
                        <v-card class="score-trans ma-1" flat>
                            <v-container>
                                <v-card class="score-trans" flat>
                                    <v-container>
                                        <p style="margin-bottom: 25px;" class="caption-font text-center">Champagne Campagne</p>
                                        <v-row>
                                            <v-card class="score-trans ma-2" flat>
                                                <v-container>
                                                    <v-label><span class="black--text" style="font-weight: bold;">Period(s)</span></v-label>
                                                    <v-divider color="#E65100" class="margin_divider"></v-divider>
                                                    <div v-for="period in discount_periods" v-bind:key="period.key">
                                                        <v-label><span class="black--text" style="font-weight: bold;">{{convertDate(period.start)}} - {{convertDate(period.end)}}</span></v-label>
                                                    </div>
                                                </v-container>
                                            </v-card>
                                            <v-card elevation="10" style="margin: 0 auto; border-top: solid 8px rgba(241, 90, 34, 1); border-bottom: solid 8px rgba(241, 90, 34, 1)" class="score-semitrans-50 text-center">
                                                <v-container>
                                                    <v-card-text>
                                                        <span v-if="nr_bookings == 0">
                                                            <p><span class="white--text intro-font ">No bookings yet...</span></p>
                                                        </span>
                                                        <span v-else>
                                                            <span class="black--text caption-font">Bookings:</span><br><br>
                                                            <span class="black--text booking-font"> {{nr_bookings}}</span>
                                                        </span>
                                                    </v-card-text>
                                                </v-container>
                                            </v-card>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-container>
                        </v-card>
                    </v-row>
                </v-responsive>
            </v-card>
            <v-divider color="white"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-icon color="white">mdi-open-in-app</v-icon>
            </v-card-actions>
        </v-container>
    </v-card>
</template>

<script>
    
    import {bus} from "../../../../main";
    import moment from 'moment';

    export default {
        data() {
            return {
                nr_bookings: 0,
                discount_code: '',
                discount_periods: [],
            }
        },
        created() {
            // here we will add the axios call to get the bookings from ares and assign the bookings var

            this.getDiscountResult();

            bus.$on("refresh", (data) => {
                console.log("refresh received for champagne " + data);
                this.getDiscountResult();
            });            
        },
        methods: {
            getDiscountResult(){
                console.log("start discount overview");
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getDiscountResults.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDiscountResults"
                    },
                    getDiscountResults: {
                        discount_code: 'CHAMPAGNE'
                    }
                    })
                    .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.nr_bookings = res.data.getDiscountResults.nr_bookings;
                        this.discount_code = res.data.getDiscountResults.discount_code;
                        this.discount_periods = res.data.getDiscountResults.discount_periods;
                    }
                    })
                    .finally(() => {
                    //this.loading = false;
                    });
            },     
            convertDate(param){
                return moment(param).format("DD-MM-YYYY");
            },       
        }                
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/champ1a.png') !important;
        background-size: cover !important;
    }
    .intro-font {
        font-size: 20px;
        font-weight: bold;
    }
    .margin_divider{
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 8px;
    }      
    .margin_outer{
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 15px;
    }    
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .booking-font {
        font-size: 60px;
        font-weight: bold;
    }
    .score-trans {
        background: transparent !important;
    }
    .score-semitrans-50 {
        background-color: rgba(225, 178, 102, 0.5);
    }
    .score-semitrans-25 {
        background-color: rgba(225, 178, 102, 0.25);
    }   
</style>